import RoomCameraEdit from './RoomCameraEdit.vue';
import RoomCamera from './RoomCamera.vue';
export { RoomCameraEdit };
export default RoomCamera;
